import { adminApi, SERVER_ERROR_MESSAGE, toAdminErrorMessage } from '../auth/adminApi';

// 상세(피드백 리포트) 실패 코드별 문구. ANALYSIS_NOT_FOUND는 오류가 아니라 "리포트 없음"으로 처리한다.
const FEEDBACK_ERROR_MESSAGES = {
    NOT_FOUND: '연습 기록을 찾을 수 없습니다.',
    SUPERVISION_MODEL_UNSUPPORTED: '이 연습의 상담 모델은 피드백 리포트를 지원하지 않습니다.',
};

// AI 내담자 사용 내역 목록을 조회한다. GET /admin/api/ai-client/list
export async function getAiClientResults() {
    let data;
    try {
        ({ data } = await adminApi.get('/admin/api/ai-client/list'));
    } catch (error) {
        throw new Error(toAdminErrorMessage(error));
    }
    if (!Array.isArray(data)) throw new Error(SERVER_ERROR_MESSAGE);
    return data;
}

// 연습의 피드백 리포트를 조회한다. 리포트를 받지 않은 연습이면 null. GET /admin/api/ai-client/:instanceId/feedback
// 응답은 회원 피드백 리포트(GET /api/mypage/ai-client-activity/:instanceId/feedback)와 같은 JSON이다.
export async function getAiClientFeedback(instanceId) {
    let data;
    try {
        ({ data } = await adminApi.get(`/admin/api/ai-client/${encodeURIComponent(instanceId)}/feedback`));
    } catch (error) {
        const code = error.response?.data?.code;
        if (error.response?.status === 404 && code === 'ANALYSIS_NOT_FOUND') return null;
        throw new Error(FEEDBACK_ERROR_MESSAGES[code] || toAdminErrorMessage(error, FEEDBACK_ERROR_MESSAGES.NOT_FOUND));
    }
    // 회원 화면(myPageApi)과 같은 기준으로 형식을 확인한다. 다르면 FeedbackReport가 빈 화면을 그린다.
    if (!data?.strengthsImprovements) throw new Error(SERVER_ERROR_MESSAGE);
    return data;
}
